<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-md(:title="$t('mantra')")

  Query(
    :query="require('~/graphql/Highlight.gql').Highlights"
    :limit="10"
    :initialValue="highlights"
    :variables="({ skip, limit }) => ({ skip, limit, type: 'MOMENT' })"
    v-slot="{ items }"
  )
    AsymetricGrid(:items="items" ref="grid" v-slot="{ item, ratio }")
      MomentCard(
        :id="item.id"
        :slug="item.slug"
        :img="item.media.src"
        :ratio="ratio"
        :title="item.caption"
        :autoRatio="true"
        :likes="item.likes"
        :isActive="$route.params.slug === item.slug"
        type="MOMENT"
        @liked="item.likes++"
      )

</template>

<script>
import { Highlights, Highlight } from '~/graphql/Highlight.gql';
import AsymetricGrid from '~/components/PsudoRandomGrid';
import Query from '~/components/Query';
import MomentCard from '~/components/MomentCard';

export default {
  components: {
    AsymetricGrid,
    Query,
    MomentCard
  },
  meta: {
    logoText: 'models'
  },
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  async asyncData({ app, params }) {
    const { data } = await app.$api.query({
      query: Highlights,
      variables: {
        type: 'MOMENT',
        limit: 10
      }
    });

    const payload = {
      highlights: data.highlights
    };

    if (params.slug && !data.highlights.items.find(h => h.slug === params.slug)) {
      const highlight = await app.$api.query({
        query: Highlight,
        variables: {
          slug: params.slug
        }
      });

      if (highlight.data.highlight) {
        payload.highlights.items.push(highlight.data.highlight);
        payload.highlight = highlight.data.highlight;
      }
    }

    return payload;
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Models",
    "pageDesc":"We create models and diagrams across the different industries to visualize concepts and provide a better thinking methodology.",
    "mantra":"Visualizing processes |and concepts. "
  },
  "ar": {
    "pageTitle":"النماذج",
    "pageDesc":"نقوم بإنشاء نماذج ومخططات عبر الصناعات المختلفة من أجل رسم الأفكار والمفاهيم لتوفير منهجية أفضل في التفكير أثناء العمل. ",
    "mantra":"التخطيط للعمليات |والأفكار والمفاهيم. "
  }
}
</i18n>
